import { render, staticRenderFns } from "./ReleaseConceptCreate.vue?vue&type=template&id=fed01d70&scoped=true&"
import script from "./ReleaseConceptCreate.vue?vue&type=script&lang=js&"
export * from "./ReleaseConceptCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed01d70",
  null
  
)

export default component.exports